// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SignalFilledSvg from "@fishx/icons-svg/es/asn/SignalFilled";
import FishxIcon from '../components/FishxIcon';

var SignalFilled = function SignalFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SignalFilledSvg
  }));
};

SignalFilled.displayName = 'SignalFilled';
export default React.forwardRef(SignalFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SignalFilled.js
// module id = 4113
// module chunks = 0